import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";

// import components
import DestroyArchiveItem from "../../components/CreateArchive/CreateArchiveItem";
import NavigationBar from "../../components/common/NavigationBar";

// Scss imports
import css from "./DestroyArchive.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import { getArchivesForDestroying } from "../../redux/actions/archiveActions";

interface DestroyArchiveProps {
  text?: string;
}

const DestroyArchive: React.FC<DestroyArchiveProps> = ({}) => {
  const dispatch = useDispatch();
  const archiveTemplate = useSelector(
    (state: any) => state.archive.archivedItemsForDestroying
  );

  const [archiveTemplateDoc, setArchiveTemplateDoc] = useState("");

  useEffect(() => {
    dispatch(getArchivesForDestroying());
  }, []);

  useEffect(() => {
    setArchiveTemplateDoc(archiveTemplate);
  }, [archiveTemplate]);
  return (
    <div>
      <NavigationBar />
      <div className={css.container}>
        {archiveTemplate && archiveTemplate.length > 0 ? (
          archiveTemplate.map((item, index) => {
            return (
              <DestroyArchiveItem
                numberOfPapers={item.numberOfPapers}
                subnumbers={item.subnumbers}
                baseNumber={item.baseNumber.baseNumber}
                index={index}
                archiveTemplate={archiveTemplate}
                createdAt={item.createdAt}
                shelfLifeToT={item.shelfLifeTo}
                remarkData={item.remark}
                id={item.id}
                content={item.content}
                key={index}
                type="destroyArchive"
              />
            );
          })
        ) : (
          <div>
            <Link to="/">
              <p>Извршили сте архивирање, идите на деловодник</p>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default DestroyArchive;
